import { forwardRef } from 'react';
import { css } from '@emotion/react';
import { useThemeValues } from '../../../../hooks';
import { styles } from '../../../../styles';
import { PolymorphicComponentPropWithRef, PolymorphicRef } from '../../../../type-utils';
import { useVerticalSlideModalContext } from '../vertical-slide-modal';

type VerticalSlideModalContentProps<C extends React.ElementType> = PolymorphicComponentPropWithRef<C>;

type VerticalSlideModalContentComponent = <C extends React.ElementType = 'div'>(
  props: VerticalSlideModalContentProps<C>
) => React.ReactNode;

export const VerticalSlideModalContent: VerticalSlideModalContentComponent = forwardRef(
  <C extends React.ElementType = 'div'>(
    { children, as, ...rest }: VerticalSlideModalContentProps<C>,
    ref: PolymorphicRef<C>
  ) => {
    const { descriptionId } = useVerticalSlideModalContext();
    const theme = useThemeValues();
    const Component = as || 'div';

    return (
      <Component
        ref={ref}
        css={[
          css`
            flex: 1;
            overflow-y: auto;
            position: relative;
          `,
          styles.smallScrollbar(theme),
        ]}
        {...rest}
        id={descriptionId}
      >
        {children}
      </Component>
    );
  }
);
